import { render, staticRenderFns } from "./upi-payment.vue?vue&type=template&id=514fe8e9&scoped=true"
import script from "./upi-payment.vue?vue&type=script&lang=js"
export * from "./upi-payment.vue?vue&type=script&lang=js"
import style0 from "./upi-payment.vue?vue&type=style&index=0&id=514fe8e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514fe8e9",
  null
  
)

export default component.exports